export const FILTER_KEYS = [
  "status",
  "brand",
  "manufacturer",
  "year",
  "category",
  "categoryWinner",
  "owner",
] as const;

export type Filters = {
  [key: string]: any;
};

export type FilterableValues = {
  [key: string]: any[];
};
